import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import ItemsTable from "./components/ItemsTable";
import { getContainerDetails } from "store/containerSlice";
import BasicInfo from "./components/BasicInfo";
import { getContainerNotes } from "store/noteSlice";

export default function OrderDetails() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const refreshList = () => {
    setRefreshTrigger((prev) => !prev);
  };
  useEffect(() => {
    dispatch(getContainerDetails({ containerId: id }));
    dispatch(
      getContainerNotes({
        relatedId: id,
        relatedModel: "containers",
      })
    );
  }, [dispatch, id, refreshTrigger]);

  return (
    <div>
      <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-1">
        <BasicInfo refreshList={refreshList} />
        <ItemsTable refreshList={refreshList} />
      </div>
    </div>
  );
}
